import { Record, Map } from 'immutable'

export const HousingResult = new Record({
  assignment: new Map(),
  confirmedGroupId: null,
  email: null,
  key: null,
  index: null,
  lottery: null
})


// WEBPACK FOOTER //
// ./src/core/housing-result/housing-result.js